import { createAction } from "@reduxjs/toolkit";
import type { IWorkspaceRadioChannelToggle } from "@somewear/radio";

export const clearRadioChannelToggles = createAction<IWorkspaceRadioChannelToggle[]>(
	"workspace/radioChannel/toggle/clear",
);

export const addRadioChannelToggles = createAction<IWorkspaceRadioChannelToggle[]>(
	"workspace/radioChannel/toggle/add",
);

export const clearAllRadioChannelTogglesForWorkspace = createAction<string>(
	"workspace/radioChannel/toggle/clearAllForWorkspace",
);
